import { Component, Input, OnChanges } from '@angular/core';
import { ComponentData, TableData } from '@ddt-web/data-service';

@Component({
	selector: 'perf-fees-overview',
	templateUrl: './fees-overview.component.html',
	styleUrls: ['./fees-overview.component.scss']
})
export class FeesOverviewComponent implements OnChanges {
	@Input() public data: ComponentData;
	@Input() public selectedPortfolioIndex: number;

	public tableData: TableData;

	public ngOnChanges(): void {
		if (this.data.success) {
			this.tableData = this.data.tabs[0].tableData[0];
		}

		if (!this.selectedPortfolioIndex) {
			this.selectedPortfolioIndex = 0;
		}
	}
}
